import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider, StyledEngineProvider, adaptV4Theme } from '@mui/material';
import { blue, red } from '@mui/material/colors';
import colors from './values/colors';
import { createRoot } from 'react-dom/client';

const theme = createTheme(adaptV4Theme({  
  palette: colors.getTheme().palette,
}))

// ReactDOM.render(
//   <React.StrictMode>
//     <StyledEngineProvider injectFirst>
//       <ThemeProvider theme={theme}>
//         <App />
//       </ThemeProvider>
//     </StyledEngineProvider>
//   </React.StrictMode>,
//   document.getElementById('root')
// );

const container = document.getElementById('root');

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </StyledEngineProvider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
